import _ from 'lodash';
import {
  rentReliefDetermination,
  isImpactedByCovidDetermination,
  code,
  nextSteps,
} from '@/app/utils/toolkit/business-rules/rent-relief/rentReliefDetermination';

export default {
  name: 'rent-relief-outcome',
  computed: {
    getItem() {
      return this.$store.getters['toolkit/getItemData'];
    },
    isJobkeeper() {
      return this.getItem.determination.jobKeeper;
    },
    hasTurnover() {
      return this.getItem.determination.turnover;
    },
    isImpactedByCovid() {
      return this.getItem.determination.impactedByCovid;
    },
    determination() {
      return rentReliefDetermination({
        isJobkeeper: this.isJobkeeper,
        hasTurnover: this.hasTurnover,
        isImpactedByCovid: this.isImpactedByCovid,
      });
    },
    outcome() {
      return this.isImpactedByCovid === 'yes';
    },
    isImpacted() {
      return isImpactedByCovidDetermination(this.isImpactedByCovid);
    },
    codeApplies() {
      return this.outcome;
    },
    code() {
      const codeHTML = code.map((item) => {
        if (typeof item.description === 'string') {
          return `<p class="mt-2">${item.description}</p>`;
        }
        if (_.isArray(item.description)) {
          return `<ul class="mx-4 list-disc list-outside text-sm">
            ${item.description
    .map(description => `<li class="mt-1">${description}</li>`)
    .join('')}
            </ul>`;
        }
        return '<p class="text-red-700">Error fetching code application for COVID-19<p>';
      });
      return codeHTML.join('');
    },
    nextSteps() {
      return nextSteps.find(step => this.outcome === step.outcome).steps;
    },
  },
  methods: {
    handleBackStep() {
      this.$emit('backStep');
    },
    handleNextStep() {
      if (this.outcome) {
        this.$emit('nextStep');
      } else {
        this.$emit('finalise');
      }
    },
  },
};
